<template>
  <b-modal
    title="Dodaj płatność"
    cancel-title="Anuluj"
    v-model="modalShow"
    @show="resetModal"
    @hidden="resetModal"
    @ok="onSubmit"
  >
    <b-form @submit.prevent="onSubmit">
      <b-form-group class="required" label="Cena jednostkowa makrocyklu [PLN]">
        <b-form-input
          v-model="unitPrice"
          type="text"
          autocomplete="off"
          :state="$v.unitPrice.$error? false : null"
          @input="$v.unitPrice.$reset()"
          @keypress="onlyForCurrency"
        />
        <b-form-invalid-feedback>
          <div v-if="!$v.unitPrice.required">To pole jest wymagane</div>
          <div v-if="!$v.unitPrice.isCorrectDecimal">Wpisana wartość jest niepoprawna</div>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group class="required" label="Liczba opłaconych makrocyklów">
        <b-form-input
          v-model="quantity"
          type="text"
          autocomplete="off"
          :state="$v.quantity.$error? false : null"
          @input="$v.quantity.$reset()"
        />
        <b-form-invalid-feedback>
          <div v-if="!$v.quantity.integer">Wpisana wartość musi być liczbą</div>
          <div v-if="!$v.quantity.required">To pole jest wymagane</div>
          <div v-if="!$v.quantity.greaterThanZero">Wartość musi być dodatnia</div>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Całkowita kwota">
        <b-form-input v-model="TotalPrice" plaintext />
      </b-form-group>

      <b-form-group label="Data księgowania" class="required">
        <date-picker
          v-model="bookedDate"
          :config="options"
          language="pl"
          autocomplete="off"
          :class="{'is-invalid': $v.bookedDate.$error}"
        ></date-picker>
        <b-form-invalid-feedback v-if="!$v.bookedDate.required">To pole jest wymagane</b-form-invalid-feedback>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required, integer } from "vuelidate/lib/validators";

function replaceCommasWithDots(value){
      let valueString = value + "";
      return valueString.split(",").join(".");
}

const greaterThanZero = value => value > 0;
const isCorrectDecimal = (value) => {
      let unitPriceWithDotsString =  replaceCommasWithDots(value);

      if (value == null ||(unitPriceWithDotsString.indexOf(".") > -1 && unitPriceWithDotsString.split(".")[1].length > 2)) {
        return false;
      }else if(unitPriceWithDotsString < 0){
        return false;
      }

      return true;
};

export default {
  data() {
    return {
      modalShow: false,
      unitPrice: null,
      quantity: 1,
      bookedDate: null,
      options: {
        format: "YYYY-MM-DD HH:mm",
        locale: "pl",
        useCurrent: true
      }
    };
  },
  computed: {
    TotalPrice: function() {
      let unitPriceWithDotsString = replaceCommasWithDots(this.unitPrice);

      var value = this.quantity * unitPriceWithDotsString;

      if (value) {
        return this.$options.filters.replaceDotsWithCommas(parseFloat(value).toFixed(2)) + " PLN";
      }
      return "-";
    },
  },
  validations: {
    unitPrice: {
      required,
      isCorrectDecimal
    },
    quantity: {
      required,
      integer,
      greaterThanZero
    },
    bookedDate: {
      required
    }
  },
  methods: {
    showModal(id) {
      axios
        .get("/Payments/price/month/admin", {
          params: {
            userId: id
          }
        })
        .then(result => {
          this.unitPrice = this.$options.filters.replaceDotsWithCommas(parseFloat(result.data).toFixed(2));
          this.modalShow = true;
        })
        .catch(error => eventBus.$emit("unhandled-error", error));
    },
    resetModal() {
      this.quantity = 1;
      this.bookedDate = null;
      this.$v.$reset();
    },
    onSubmit(bvModalEvt) {
      this.$v.$touch();
      bvModalEvt.preventDefault();

      let unitPriceString  =  replaceCommasWithDots(this.unitPrice);

      if (!this.$v.$error) {
        axios
          .post("/Payments", {
            userId: this.userId,
            unitPrice: unitPriceString,
            quantity: this.quantity,
            bookedDate: this.bookedDate
          })
          .then(() => {
            eventBus.$emit("notify-success", "Dodano nową płatność");
            this.$emit("payment-added");
            this.modalShow = false;
          })
          .catch(error => eventBus.$emit("unhandled-error", error));
      }
    },
    onlyForCurrency($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      let unitPriceString = this.unitPrice + "";
      unitPriceString = replaceCommasWithDots(unitPriceString);

      // only allow number and one comma
      if ((keyCode < 48 || keyCode > 57) &&(keyCode !== 44 || unitPriceString.indexOf(".") != -1)) { // 46 is dot, 44 is comma
        $event.preventDefault();
      }

      if($event.target.selectionStart > unitPriceString.indexOf(".") && unitPriceString.indexOf(".") != -1){
        if (this.unitPrice != null && unitPriceString.indexOf(".") > -1 && unitPriceString.split(".")[1].length > 1) {
          $event.preventDefault();
        }
      }

      if($event.target.selectionStart == 0 && $event.key == 0){
          $event.preventDefault();
      }
    },
  },
  props: {
    userId: String
  }
};
</script>

<style lang="scss" scoped>
</style>